// En premier, avant React : l'instantané de contrôle doit précéder tout effet (voir le module).
import "./lib/controleAuChargement";
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { mountWallDiagnostics } from "@/lib/wallDiagnostics";
import { loadBootLangs } from "@/lib/bootLang";

// « Le mur doit pouvoir dire ce qu'il a » — le panneau de diagnostic de
// `?display=conte&debug=1`, peint en DOM nu AVANT que React n'existe. C'est
// tout l'intérêt de l'endroit où cette ligne se trouve : un diagnostic qui
// attendrait que l'application se monte ne servirait à rien le jour où c'est
// justement l'application qui ne se monte pas. Silencieux partout ailleurs
// (aucun nœud, aucun écouteur) — voir lib/wallDiagnostics.js.
mountWallDiagnostics();

// ⚑ LA LANGUE DU PREMIER ÉCRAN ARRIVE AVANT LUI (audit 10/09 bis, perf n°4).
// Les six langues autres que le français sont chacune leur propre chunk ;
// un visiteur de `/de/autun` (ou un téléphone allemand) attend le sien —
// quelques kilo-octets, demandés dès la coquille par plugins/preload-lang.js
// — avant que React ne monte, pour ne jamais voir passer le français. Un
// visiteur français ne paie rien : la promesse est déjà résolue. Et un chunk
// qui n'arrive pas ne bloque pas la page (lib/bootLang.js résout toujours).
const root = ReactDOM.createRoot(document.getElementById("root"));
loadBootLangs().then(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});

// PWA: register the service worker (production only — never in dev, where a
// cached shell would mask hot reloads). sw.js is network-first for HTML and
// for the read-only catalogue (/api/medard/monuments…), whose last good copy
// is served only when the network is dead; every other /api/* is never
// touched — so guests always get the latest deploy and the latest fact.
if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    // Reload once when a NEW service worker takes control. sw.js calls
    // skipWaiting() on install and clients.claim() on activate, so a fresh
    // deploy activates immediately; reloading re-runs the page against the new
    // shell and assets. Guard against the first-ever install (no prior
    // controller) and against reload loops.
    const hadController = Boolean(navigator.serviceWorker.controller);
    let reloading = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (!hadController || reloading) return;
      reloading = true;
      window.location.reload();
    });

    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL || ""}/sw.js`)
      .then((registration) => {
        // Check for a new build on this load, and again whenever the PWA
        // returns to the foreground — this is what pulls a fresh deploy to an
        // already-installed home-screen app promptly.
        registration.update();
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") registration.update();
        });
      })
      .catch(() => {
        // Registration failure is non-fatal: the app simply runs un-installed.
      });
  });
}
